<template>
    <Teleport to="body">
        <div v-if="show" class="guest-blocking-overlay">
            <div class="blocking-modal">
                <div class="modal-icon">
                    <Lock :size="48" />
                </div>
                <h2>Create an Account to Access</h2>
                <p>Sign up for free to unlock {{ featureName }} and track your progress.</p>
                <div class="modal-actions">
                    <router-link to="/register" class="btn btn-primary">
                        Create Free Account
                    </router-link>
                    <router-link to="/login" class="btn btn-secondary">
                        Log In
                    </router-link>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import { watch } from 'vue';
import { Lock } from 'lucide-vue-next';

const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    featureName: {
        type: String,
        default: 'this feature'
    }
});

watch(() => props.show, (val) => {
    document.body.style.overflow = val ? 'hidden' : '';
}, { immediate: true });
</script>

<style scoped>
.guest-blocking-overlay {
    position: fixed;
    top: 0;
    left: 70px; /* Account for sidebar width */
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 500; /* Below sidebar (1000) so users can navigate */
}

.blocking-modal {
    background: var(--bg-primary, #13111c);
    border: 1px solid rgba(255, 222, 122, 0.4);
    padding: 40px;
    max-width: 400px;
    text-align: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.modal-icon {
    color: var(--accent, #ffde7a);
    margin-bottom: 20px;
}

.blocking-modal h2 {
    color: var(--text-primary, #fff6e3);
    font-size: 24px;
    margin-bottom: 12px;
}

.blocking-modal p {
    color: var(--text-secondary, #fee7b3);
    font-size: 14px;
    margin-bottom: 24px;
    line-height: 1.5;
}

.modal-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.btn {
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: transform 0.2s, box-shadow 0.2s;
    display: block;
}

.btn-primary {
    background: var(--accent, #ffde7a);
    color: var(--bg-primary, #13111c);
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 222, 122, 0.3);
}

.btn-secondary {
    background: transparent;
    color: var(--text-primary, #fff6e3);
    border: 1px solid rgba(255, 246, 227, 0.3);
}

.btn-secondary:hover {
    background: rgba(255, 246, 227, 0.1);
}

/* Mobile: no sidebar, so overlay full width */
@media (max-width: 768px) {
    .guest-blocking-overlay {
        left: 0;
    }
}
</style>
